import React, { FunctionComponent } from 'react';
import { useLocation } from 'react-router-dom';
import { getNominatorMail, getNominatorName } from './common';
import { sendMail } from './services';
import { getConfig } from '../services/ConfigService';
import { store } from '../store/store';
import { setShowError } from '../actions/errorActions';


let siteUrl: string;
let fromEmail: string;

const refineName = (name: string) => {
    if (name.includes(',')) {
        let nameSplit: any = name.split(',');
        name = nameSplit[1] + " " + nameSplit[0].trim();
    }
    return name;
}


export const sendNominatorMail = async (details: any) => {
    return getConfig().then((config: any) => {
        siteUrl = config.SiteUrl;
        fromEmail = config.VIAEmail;
        let toEmail=getNominatorMail()
            let options = {
                "from": fromEmail,
                "to": toEmail,
                "message": `<div>
                            <text>Good News!</text>
                            <br />
                            <br />
                            <text>Your nomination of `+ refineName(details.name) + ` for Values in Action award has been submitted. We emailed your nominee a congratulatory note and link to your full nomination. <a href=` + siteUrl + `>Visit our VIA nominations center</a> to nominate someone else or view all of your past nominations.</text>
                            <br /> 
                            <br />
                            <text>Sincerely,</text> 
                            <br />
                            <br />
                            <text>The VIA Nominations Team</text>
                            <br />
                            <br />
                            *** Do Not reply to this automated email *** 
                            </div>`,
                "subject": "You've submitted a Values in Action nomination"
            }
            sendMail(options);    
        
    });

}

export const sendNomineeMail = async (details: any) => {
    return getConfig().then((config: any) => {
        siteUrl = config.SiteUrl;
        fromEmail = config.VIAEmail;
            let options = {
                "from": fromEmail,
                "to": details.mail,
                "message": `<div>
                            <text>Hi `+ refineName(details.name) + `</text>
                            <br />
                            <br />
                            <text>Congratulations! You have been nominated for a Values in Action award. Thank you for your outstanding commitment and dedication to Providence St. Joseph Health, your colleagues, and those we serve. Go back to <a href=` + siteUrl + `>our VIA nominations center</a> and select 'Received' to view your nomination.</text>
                            <br /> 
                            <br />
                            <text>Sincerely,</text> 
                            <br />
                            <br />
                            <text>The VIA Nominations Team</text>
                            <br />
                            <br />
                            *** Do Not reply to this automated email *** 
                            </div>`,
                "subject": "You've received a Values in Action nomination!"
            }
            sendMail(options);
    });
}

export const sendNomineeManagerMail = async (details: any) => {
    return getConfig().then((config: any) => {
        siteUrl = config.SiteUrl;
        fromEmail = config.VIAEmail;
        if(!details.isAnonymous)
        {
            let options = {
                "from": fromEmail,
                "to":  details.managerEmail,
                "message": `<div>
                            <text>Good News!</text>
                            <br />
                            <br />
                            <text>`+ refineName(details.name) + ` has received a Values in Action nomination from `+ refineName(details.nominatorName) +` for the nomination year of ` + (details.nominationYear) +`. The nomination reads:</text>
                            <br />
                            <br />
                            <i>`+ (details.nominationNotes) +`</i>
                            <br />
                            <br />
                            <text>We emailed the nominee a congratulation note and link to the personal nomination. Please join us in congratulating them!.</text>
                            <br /> 
                            <br />
                            <text>Please <a href=` + siteUrl + `>Visit our VIA nominations center</a> to nominate someone or view past nominations that you have received or submitted.</text>
                            <br /> 
                            <br />
                            <text>Sincerely,</text> 
                            <br />
                            <br />
                            <text>The VIA Nominations Team</text>
                            <br />
                            <br />
                            *** Do Not reply to this automated email *** 
                            </div>`,
                "subject": "A member of your team received a Values in Action nomination"
            }
            sendMail(options);
        }
        else 
        {
            let options = {
                "from": fromEmail,
                "to":  details.managerEmail,
                "message": `<div>
                            <text>Good News!</text>
                            <br />
                            <br />
                            <text>`+ refineName(details.name) + ` has received a Values in Action nomination for the nomination year of ` + (details.nominationYear) +`. The nomination reads:</text>
                            <br />
                            <br />
                            <i>`+ (details.nominationNotes) +`</i>
                            <br />
                            <br />
                            <text>We emailed the nominee a congratulation note and link to the personal nomination. Please join us in congratulating them!.</text>
                            <br /> 
                            <br />
                            <text>Please <a href=` + siteUrl + `>Visit our VIA nominations center</a> to nominate someone or view past nominations that you have received or submitted.</text>
                            <br /> 
                            <br />
                            <text>Sincerely,</text> 
                            <br />
                            <br />
                            <text>The VIA Nominations Team</text>
                            <br />
                            <br />
                            *** Do Not reply to this automated email *** 
                            </div>`,
                "subject": "A member of your team received a Values in Action nomination"
            }
            sendMail(options);
        }          
    });
}


/* let options = {
    "from": fromEmail,
    "to":  details.managerEmail,
    "message": `<div>
                <text>Good News!</text>
                <br />
                <br />
                <text>`+ refineName(details.name) + ` has received a Values in Action nomination. We emailed the nominee a congratulatory note and link to the personal nomination. Please join us in congratulating them!.</text>
                <br /> 
                <br />
                <text>Please <a href=` + siteUrl + `>Visit our VIA nominations center</a> to nominate someone or view past nominations that you have received or submitted.</text>
                <br /> 
                <br />
                <text>Sincerely,</text> 
                <br />
                <br />
                <text>The VIA Nominations Team</text>
                <br />
                <br />
                *** Do Not reply to this automated email *** 
                </div>`,
    "subject": "A member of your team received a Values in Action nomination" */